<ion-modal class="modalCustom" #modal (ionModalDidDismiss)="onDismiss()">
  <ng-template>
    <!-- Para no cargar los Stores de todos los defectos de la aplicación, usamos un ngIf para que el Combo solo cargue cuando se visualice el modal.-->
    <ng-container *ngIf="modal.isOpen">
      <ion-header>
        <ion-toolbar>
          <ion-buttons slot="end">
            <ion-button (click)="modal.dismiss()"><ion-icon name="close"></ion-icon></ion-button>
          </ion-buttons>
          <ion-title>Defectos</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding" [formGroup]="form">
        <ion-list class="listInfo">
          <ng-container [formGroup]="modalGroup">
            <fv-combobox-with-store #combo formControlName label="Añadir defecto" placeholder="[Selecciona un defecto]"
            modal-title="Seleccione tipo" display-field="Defecto" value-field="Id" [data-source]="GetDefectosStore()"
            [readonly]="false" [obligatorio]="false" formControlName="DefectoSeleccionado">
            <ng-template #itemTpl let-item="item">
              <ion-item class="itemList" button>
                <ion-label>
                  <ion-icon name="caret-forward" class="iconLabel mr-2"></ion-icon>
                  {{item.Valoracion}} - {{item.Defecto}}
                </ion-label>
              </ion-item>
            </ng-template>
          </fv-combobox-with-store>
          </ng-container>

          <ng-container formArrayName="DefectosEstablecidos">
            <ng-container *ngFor="let defecto of defectosEstablecidos.controls; let index = index" [formGroupName]="index">
              <!-- <ion-item>
                <fv-textinput label="Defecto" [readonly]="true" formControlName="Defecto" [obligatorio]="false"></fv-textinput>
              </ion-item> -->
             <div class="boxDefecto">
              <div class=" boxHeader d-flex align-items-center justify-content-between">
                <p class="mb-0 subtitleModal">{{GetValoracion(defecto.get('ValoracionId')?.value, GetValoracionesStore() | async)}} - {{defecto.get('Defecto')?.value}}</p>
                <div class="btnIcon">
                  <ion-button color="danger" (click)="EliminarDefecto(defecto)"><ion-icon name="trash" class="mr-0"></ion-icon></ion-button>
                </div>
              </div>
              <div class="boxContent">
                <ion-item>
                  <!-- <ion-textarea label="Observaciones" formControlName="Observaciones"></ion-textarea> -->
                  <app-text-area label="Observaciones" formControlName="Observaciones"></app-text-area>
                </ion-item>
              </div>
             </div>
              
            </ng-container>
          </ng-container>
          
        </ion-list>
      </ion-content>
      <ion-footer>
        <ion-buttons slot="end" class="ml-auto">
          <ion-button (click)="modal.dismiss()" class="btn1 ml-auto">Aceptar</ion-button>
        </ion-buttons>
      </ion-footer>
    </ng-container>
  </ng-template>
</ion-modal>